import EstatedProperty from "../entities/EstatedProperty";

const estatedUrl = process.env.REACT_APP_ESTATED_URL;
const estatedKey = process.env.REACT_APP_ESTATED_API_KEY;
const riskUrl = process.env.REACT_APP_RISK_URL;

export const fetchEstated = (params) => {
  const urlParams = new URLSearchParams(params);
  const url = `${estatedUrl}/estated?${urlParams}`;
  return fetch(url, { method: "GET", headers: { "x-api-key": estatedKey } })
    .then(async (response) => {
      const values = JSON.parse(await response.text())[0];
      const property = new EstatedProperty(values);
      if (params.lat) {
        property.address.latitude = params.lat;
      }
      if (params.lng) {
        property.address.longitude = params.lng;
      }
      if (params.county) {
        property.address.county = params.county;
        property.property_info.county = params.county;
      }
      return property;
    })
    .catch(() => {
      return null;
    });
};

export const fetchRisk = (params) => {
  const url = `${riskUrl}/features/v1/${params.lat},${params.lng}`;
  return fetch(url, { method: "GET" }).then(async (response) => {
    return JSON.parse(await response.text());
  });
};

export const fetchDistanceToFirehydrant = (params) => {
  const url = `https://x5rmw0fpj9.execute-api.us-east-1.amazonaws.com/dev/firehydrants?lat=${params.lat}&lon=${params.lng}`;
  return fetch(url, { method: "GET" }).then(async (response) => {
    return JSON.parse(await response.text());
  }).catch(() => {
    return null
  });
};

export const downloadBreakout = (estatedProperty, body, addr, type) => {
  const fileName = `${addr.formatted_street_address}, ${addr.city}, ${addr.state} ${addr.zip_code} - Replacement Costs (${type}).pdf`;
  let promise;
  if (body) {
    const url = `${estatedUrl}/replacement_cost_calculator_export?type=${type}`;
    promise = fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": estatedKey,
      },
      body: JSON.stringify({
        ...addr,
        ...body,
      }),
    });
  } else if (estatedProperty.replacement_costs.zip_code) {
    const url = `${estatedUrl}/replacement_cost_calculator_export?type=${type}`;
    promise = fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": estatedKey,
      },
      body: JSON.stringify({
        ...estatedProperty.replacement_costs,
        ...addr,
        year_built: estatedProperty.property_info.year_built,
      }),
    });
  }
  return promise.then(async (response) => {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};

export const calculateReplacementCost = (payload) => {
  const url = `${estatedUrl}/replacement_cost_calculator`;
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": estatedKey,
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    return await response.json();
  });
};

export const downloadFloodMap = (addr, uri) => {
  const fileName = `${addr.formatted_street_address}, ${addr.city}, ${addr.state} ${addr.zip_code} - Flood Map.pdf`;
  const url = `${estatedUrl}/flood_map_export`;
  const promise = fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": estatedKey,
    },
    body: JSON.stringify({ ...addr, uri }),
  });
  return promise.then(async (response) => {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};

export const fetchSearchResults = (filters) => {
  const url = `${estatedUrl}/search`;
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": estatedKey,
    },
    body: JSON.stringify(filters),
  }).then(async (response) => {
    const results = await response.json();
    return results.map((_) => ({ id: _.fips + _.apn, ..._ }));
  });
};

export const fetchMortgageRates = (filters) => {
  const url = `${estatedUrl}/mortgage_rates`;
  return fetch(url, {
    method: "GET",
    headers: {
      "x-api-key": estatedKey,
    },
  }).then(async (response) => {
    return JSON.parse(await response.text());
  });
};
